module.exports = __webpack_public_path__ + "static/img/sjyhead.b336c11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/sjyhead.jpg
// module id = 253
// module chunks = 34